import script from "./UpcomingMeeting.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingMeeting.vue?vue&type=script&setup=true&lang=js"

import "./UpcomingMeeting.vue?vue&type=style&index=0&id=680a47f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680a47f0"]])

export default __exports__